import React, { useContext } from 'react';
import { ThemeContext } from '../context/themeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import logo_light from './logooo-tttt_light.png';
import logo_dark from './logooo-tttt.png';
import { faFacebookF, faTwitter, faInstagram, faCcVisa, faCcMastercard, faCcPaypal } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';  // Correct import for Link component

const Footer = () => {
  const { darkMode, toggleTheme } = useContext(ThemeContext);

  return (
    <footer className="bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 py-12">
      <div className=" mx-auto px-4">
        <div className="flex flex-wrap justify-between items-center mb-10">
          <div className="w-full sm:w-1/2 md:w-1/4 mb-6 flex justify-center sm:justify-start">
            <img
              className="block w-auto h-20 w-24 dark:hidden"
              src={logo_dark}
              alt="Logo"
            />
            <img
              className="hidden w-auto h-20 w-24 dark:block"
              src={logo_light}
              alt="Dark Logo"
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between">
          {/* Shop Section */}
          <div className="w-full sm:w-1/2 md:w-1/4 mb-6">
            <h5 className="font-bold text-lg mb-3 dark:text-white">Shop</h5>
            <ul>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">New Arrivals</a></li>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Best Sellers</a></li>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Sale</a></li>
            </ul>
          </div>

          <div className="w-full sm:w-1/2 md:w-1/4 mb-6">
            <h5 className="font-bold text-lg mb-3 dark:text-white">Customer Service</h5>
            <ul>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Help Center</a></li>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Shipping Info</a></li>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Returns</a></li>
            </ul>
          </div>

          <div className="w-full sm:w-1/2 md:w-1/4 mb-6">
            <h5 className="font-bold text-lg mb-3 dark:text-white">Legal</h5>
            <ul>
            <li className="mb-1">
  <Link to="/privacy" className="hover:underline text-gray-600 dark:text-gray-400">
    Privacy Policy
  </Link>
</li>              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Terms of Service</a></li>
              <li className="mb-1"><a  className="hover:underline text-gray-600 dark:text-gray-400">Cookie Policy</a></li>
            </ul>
          </div>

          <div className="w-full sm:w-1/2 md:w-1/4 mb-6">
            <h5 className="font-bold text-lg mb-3 dark:text-white">Follow Us</h5>
            <ul className="flex space-x-4">
              <li>
                <a href="https://facebook.com" className="hover:underline" aria-label="Facebook">
                  <FontAwesomeIcon icon={faFacebookF} className="w-6 h-6 text-gray-600 dark:text-gray-400" />
                </a>
              </li>
              <li>
                <a href="https://twitter.com" className="hover:underline" aria-label="Twitter">
                  <FontAwesomeIcon icon={faTwitter} className="w-6 h-6 text-gray-600 dark:text-gray-400" />
                </a>
              </li>
              <li>
                <a href="https://instagram.com" className="hover:underline" aria-label="Instagram">
                  <FontAwesomeIcon icon={faInstagram} className="w-6 h-6 text-gray-600 dark:text-gray-400" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex justify-between items-center mt-8">
          {/* Payment Icons */}
          <div className="flex space-x-4">
            <FontAwesomeIcon icon={faCcVisa} className="w-8 h-8 text-gray-600 dark:text-gray-400" />
            <FontAwesomeIcon icon={faCcMastercard} className="w-8 h-8 text-gray-600 dark:text-gray-400" />
            <FontAwesomeIcon icon={faCcPaypal} className="w-8 h-8 text-gray-600 dark:text-gray-400" />
          </div>

        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-gray-500 dark:text-gray-400">&copy; 2024 OnlySale. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
